export const Q_VIEW_OPTIONS = [
  "LastPeriodIndicatorId",
  "place",
  "GroupIndicatorId",
];
